export default function BankDetailsTable({ details }) {
  return (
    <table className="bank-table">
      <tbody>
        {details.map(([label, value]) => (
          <tr key={label}>
            <th>{label}</th>
            <td>{value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
